import React from 'react';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import { H2, P12, P16 } from 'client/v3/typography';
import Image from '@ff/ui/Image';
import url from 'client/utils/url';

export type OptionProps = {
  name: string;
  title?: string;
  description?: string[];
  imageUrl?: string;
  price?: number;
  learnMoreContent?: JSX.Element | null;
}

export function HomeCharger() {
  const imageUrl = `${url.getCDNDomainV2()}/configurator/design/images/other/FF91_Sidebar_Option_Home_Charger.png`;

  return (
    <Container>
      <H2>Home Charger</H2>
      <OptionImage src={imageUrl} alt='Home Charger'/>
      <TextLinesGroup>
        <TextLine>Smart, Wi-Fi connected EV charger</TextLine>
        <TextLine>Indoor/Outdoor installation</TextLine>
        <TextLine>24-foot cable</TextLine>
        <TextLine>Level 2 Charging up to 19.2kW</TextLine>
      </TextLinesGroup>
      <TextLinesGroup>
        <TextLine>FF Installation Services Partner, Qmerit</TextLine>
      </TextLinesGroup>
      <TextLinesGroup2>
        <TextLine2>We&apos;ve partnered with Qmerit to connect you with the best technicians near you, for a seamless home charging installation experience</TextLine2>
        <TextLine2>As an Alliance user, our partner Qmerit Concierge Service will contact you to discuss your home charging installation needs.</TextLine2>
        <TextLine2>Included up to $5,500 credit towards installation</TextLine2>
      </TextLinesGroup2>
      <Include>Included</Include>
    </Container>
  );
}

export function PublicChargingCredit() {
  const imageUrl = `${url.getCDNDomainV2()}/configurator/design/images/other/FF91_Sidebar_Option_Public_Charging_Credit.png`;

  return (
    <Container>
      <H2>Public Charging Credit</H2>
      <OptionImage src={imageUrl} alt='Public Charging Credit'/>
      <TextLine>FF offers $1,000 charging credit on participating public charging networks</TextLine>
      <TextLine>Valid for 3 years at time of vehicle purchase</TextLine>
      <Include>Included</Include>
    </Container>
  );
}

export function FFPortableChargingCable() {
  const imageUrl = `${url.getCDNDomainV2()}/configurator/design/images/other/FF91_Sidebar_Option_Portable_Charging_Cable.png`;

  return (
    <Container>
      <H2>FF Portable Charging Cable</H2>
      <OptionImage src={imageUrl} alt='FF Portable Charging Cable'/>
      <TextLinesGroup>
        <TextLine>Dual Power Level 1/Level 2</TextLine>
        <TextLine>Support up to 9.6kW</TextLine>
      </TextLinesGroup>
      <Include>Included</Include>
    </Container>
  );
}


const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  textAlign: 'center',
  alignItems: 'center',
  gap: '32px',
});

const TextLine = styled(P16)({
  lineHeight: '20px'
})

const TextLinesGroup = styled(Box)({
});

const TextLinesGroup2 = styled(Box)({
  paddingLeft: '24px',
  paddingRight: '24px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
})
const TextLine2 = styled(P12)({
  textAlign: 'left',
  color: 'rgb(0, 0, 0, 0.5)',
  lineHeight: '14px'
})

const Include = styled(P16)({
  fontWeight: 300,
})

const OptionImage = styled(Image)({
  maxWidth: '240px',
});